export default async ({ store, router }) => {
	// store._vm is not the correct root but has access to $q
	const $q = store._vm.$q;

	// Available after app mounted not on this time
	const getRoot = () => router.app;

	// Wrap original dialog function
	const dialog = $q.dialog;
	$q.dialog = function(options, props = {}) {
		// Direct component input
		if (options.render) {
			options = {
				component: options,
			};
		}

		return dialog({
			root: getRoot(),
			...options,
			...props,
		});
	};
};
